/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Col, Form, Dropdown, Button, ListGroup } from 'react-bootstrap';
import {
  DotsHorizontalIcon,
  ViewGridAddIcon,
  TrashIcon,
} from '@heroicons/react/solid';

export interface IKanbanListProps {
  id: any;
  listRef: any;
  extraProps?: any;
  title?: string;
  onTitleChange?({ id, title }: any): void;
  onCardAdd?(id: any): void;
  onListDelete?(id: any): void;
  addCardLabel?: string;
  children: any;
}

export const KanbanList = (props: IKanbanListProps) => {
  const { id, listRef, extraProps = {} } = props;
  const [title, setTitle] = useState(props.title ?? '');
  const [isTitleEditable, setIsTitleEditable] = useState(false);

  const onTitleChange = () => {
    props.onTitleChange && props.onTitleChange({ id, title });
    toggleIsTitleEditable();
  };

  const toggleIsTitleEditable = () => {
    setIsTitleEditable(!isTitleEditable);
  };

  const onCardAdd = () => {
    props.onCardAdd && props.onCardAdd(id);
  };

  const onListDelete = () => {
    props.onListDelete && props.onListDelete(id);
  };

  const _renderDropDownActions = () => {
    return (
      <Dropdown>
        <Dropdown.Toggle
          as={Button}
          variant="link"
          size="sm"
          className="fs-6 px-1 py-0"
        >
          <DotsHorizontalIcon className="icon icon-xs text-gray-500" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start mt-2 py-1">
          <Dropdown.Item
            className="d-flex align-items-center"
            onClick={onCardAdd}
          >
            <ViewGridAddIcon className="icon icon-xs text-gray-400 me-2" />{' '}
            {props.addCardLabel}
          </Dropdown.Item>
          <Dropdown.Divider as="div" className="my-1" />

          {/*<Dropdown.Item*/}
          {/*  className="d-flex align-items-center"*/}
          {/*  onClick={onListDelete}*/}
          {/*>*/}
          {/*  <TrashIcon className="icon icon-xs text-danger me-2" /> Remove*/}
          {/*</Dropdown.Item>*/}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <Col xs={12} lg={8} xl={8} xxl={6} ref={listRef} {...extraProps}>
      <div className="d-flex justify-content-between align-items-center kanban-title-container mb-2">
        <h5
          className="kanban-title d-flex align-items-center w-100 fs-6 fw-bold p-2 m-0"
          onClick={toggleIsTitleEditable}
        >
          {title}
        </h5>
        {_renderDropDownActions()}
      </div>
      <ListGroup className="kanban-list">{props.children}</ListGroup>
    </Col>
  );
};

KanbanList.defaultProps = {
  addCardLabel: 'Add',
};
